'use strict';

fbPreventNavigation.$inject = ["gettextCatalog", "$transitions", "dialogService", "$parse"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fbPreventNavigation = fbPreventNavigation;
function fbPreventNavigation(gettextCatalog, $transitions, dialogService, $parse) {
    'ngInject';

    return {
        restrict: 'A',
        require: 'form',
        link: function link(scope, element, attribute, form) {

            var destroyOnExitHandler = $transitions.onExit({}, function () {
                return !attribute.fbPreventNavigation || !form.$dirty || dialogService.unsavedChanges().then(function () {
                    form.$setPristine();
                    return true;
                }, function () {
                    $parse(attribute.fbOnCloseAction)(scope);
                    return false;
                });
            });

            // Cleanup
            element.on('$destroy', function () {
                if (destroyOnExitHandler) {
                    destroyOnExitHandler();
                }
            });
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/directives/fb-prevent-navigation.js
// module id = 720
// module chunks = 0